import React from "react";
import ReactDOM from "react-dom";
import "./main.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";

const AppWithRouter = withRouter(App);

ReactDOM.render(
  // <React.StrictMode>
  <Router>
    <AppWithRouter />
  </Router>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
